module.exports = __webpack_public_path__ + "static/img/chanyeziyuan.79f75a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/7mouth/chanyeziyuan.png
// module id = ugHS
// module chunks = 1